// import { ReactComponent as SubnetMappingsStatusIcon } from "@/Icons/subnet-mappings-status.svg"
import BifrostButton from "@/Components/BifrostElementComponent/BifrostButton/BifrostButton.jsx"
import BifrostModal from "@/Components/BifrostPageComponent/BifrostModal/BifrostModal.jsx"
import { useTimeZoneConverter } from "@/Hooks"
import { ReactComponent as SubnetMappingsStatusIcon } from "@/Icons/subnet-mappings-status.svg"
import { ReactComponent as UnitSimpleDisconnectedIcon } from "@/Icons/unit-simple-disconnected.svg"
import { useMemo } from "react"
import { Dropdown, Feed, Header, Icon, Label, List, Message, Popup, Segment, Table } from "semantic-ui-react"
import AddSubnetMappingModal from "../AddSubnetMappingModal"
import RemoveSubnetMappingModal from "../RemoveSubnetMappingModal"
import { useSubnetMappingsTable } from "./hooks"

const SubnetMappingsTable = ({ directTunnelStatus, directTunnelData, getDirectTunnelSubnetMapping }) => {
	const { subnetMappingsTable, openMessageModal, openMassageModalHandler, messageModalContent } = useSubnetMappingsTable(directTunnelData)
	const { convertToBrowserTimeZone } = useTimeZoneConverter()
	const { data: directTunnelStatusData } = directTunnelStatus

	const tableHeader = useMemo(
		() => [
			{ key: "status", content: "Status", width: 2 },
			{ key: "user", content: "User", width: 2 },
			{ key: "subnet", content: "Subnet", width: 2 },
			{ key: "mode", content: "Mode", width: 2 },
			{ key: "activation", content: "Activation", width: 3 },
			{ key: "deactivation", content: "Deactivation", width: 3 },
			{ key: "reason", content: "Reason", width: 3 },
			{ key: "actions", content: "", width: 1 }
		],
		[]
	)

	return (
		<Feed>
			<Feed.Event>
				<Feed.Content>
					<Feed.Extra>
						<Table basic="very" compact="very" stackable>
							<Table.Header>
								<Table.Row>
									{tableHeader.map((item, index) => (
										<Table.HeaderCell key={index} width={item.width}>
											{item.content}
										</Table.HeaderCell>
									))}
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{subnetMappingsTable.length !== 0 ? (
									subnetMappingsTable.map((item, index) => {
										return (
											<Table.Row key={index}>
												<Table.Cell>
													{directTunnelStatusData?.enableDirectTunnel ? (
														<SubnetMappingsStatusIcon style={{ margin: "auto" }} fill={item.status ? "#19CCA3" : "#ADB6BC"} />
													) : (
														<Popup position="left center" trigger={<UnitSimpleDisconnectedIcon style={{ margin: "auto" }} />}>
															<Popup.Header>Bifrost Unit</Popup.Header>
															<Popup.Content>The Direct Tunnel service is disconnected on the Bifrost Unit.</Popup.Content>
															<Popup.Content>To activate it, toggle Direct Tunnel on.</Popup.Content>
														</Popup>
													)}
												</Table.Cell>
												<Popup position="left center" trigger={<Table.Cell>{item.name ? item.name : item.email || "Unknown"}</Table.Cell>}>
													<Popup.Header>{item.name ? item.name : item.email || "Unknown"}</Popup.Header>
													<Popup.Content>{item.email}</Popup.Content>
													<Popup.Header>Peers</Popup.Header>
													<Popup.Content>
														{item.peers.length === 0 ? (
															<Label color="grey" basic>
																No peers
															</Label>
														) : (
															<List bulleted>
																{item.peers.map((peer, index) => (
																	<List.Item key={index}>{peer}</List.Item>
																))}
															</List>
														)}
													</Popup.Content>
												</Popup>
												<Table.Cell>{item.subnet}</Table.Cell>
												<Table.Cell>{item.mode ? item.mode : "Unknown"}</Table.Cell>
												<Table.Cell>{item.activation ? convertToBrowserTimeZone(item.activation) : "N/A"}</Table.Cell>
												<Table.Cell>{item.deactivation ? convertToBrowserTimeZone(item.deactivation) : "N/A"}</Table.Cell>
												<Table.Cell singleLine selectable>
													<BifrostModal
														title="Message"
														open={openMessageModal}
														closeOnEscape={true}
														closeOnDimmerClick={true}
														setOpen={(open) => openMassageModalHandler(open, item.reason)}
														trigger={
															<div
																style={{
																	width: "12em",
																	textOverflow: "ellipsis",
																	overflow: "hidden",
																	whiteSpace: "nowrap",
																	cursor: "pointer"
																}}
															>
																{item.reason ? item.reason : "N/A"}
															</div>
														}
														modalPage={
															<Message
																style={{
																	color: "black",
																	whiteSpace: "pre-line"
																}}
															>
																{messageModalContent}
															</Message>
														}
														modalActions={
															<>
																<BifrostButton style={{ display: "inline-block" }} onClick={() => openMassageModalHandler(false, null)} color="gray">
																	Close
																</BifrostButton>
															</>
														}
													/>
												</Table.Cell>
												<Table.Cell>
													<Dropdown icon="ellipsis horizontal" direction="left">
														<Dropdown.Menu>
															<Dropdown.Item>
																<RemoveSubnetMappingModal index={index} item={item} refresh={getDirectTunnelSubnetMapping} />
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</Table.Cell>
											</Table.Row>
										)
									})
								) : (
									<Table.Row>
										<Table.Cell style={{ paddingTop: "40px", textAlign: "center", fontSize: "20px" }} colSpan={100} rowSpan={2}>
											<Segment basic>
												<Header icon>
													<Icon name="search" color="grey" style={{ marginBottom: "20px" }} />
													No results found
												</Header>
											</Segment>
										</Table.Cell>
									</Table.Row>
								)}
							</Table.Body>
						</Table>
						<AddSubnetMappingModal directTunnelData={directTunnelData} getDirectTunnelSubnetMapping={getDirectTunnelSubnetMapping} />
					</Feed.Extra>
				</Feed.Content>
			</Feed.Event>
		</Feed>
	)
}

export default SubnetMappingsTable
